import { Color } from '@lux/wardrobe-lib'

export const statusColors = {
    draft: Color.GREY2,
    new: Color.VIOLET,
    read: Color.BLUE,
    toBeReleased: Color.WARNING,
    released: Color.LIGHT_BLUE,
    redo: Color.YELLOW,
    inProgress: Color.WARNING,
    rejected: Color.ERROR,
    inApproval: Color.TEAL,
    rework: Color.YELLOW,
    overdue: Color.PINK,
    cancelled: Color.ERROR,
    planned: Color.LIGHT_BLUE,
    closed: Color.GREEN,
    saved: Color.LIGHT_BLUE,
    approvedWithWarning: Color.BROWN,
    approved: Color.GREEN,
    publishedWithWarning: Color.TEAL,
    published: Color.PURPLE,
    recalled: Color.RED,
}

export const chartStatusColors = {
    draft: '#9ea0a1',
    new: '#c46ced',
    read: '#5c8db8',
    toBeReleased: '#db7c0c',
    released: '#228ec8',
    redo: '#bd8802',
    inProgress: '#db7c0c',
    rejected: '#ee312f',
    inApproval: '#2aa092',
    rework: 'yellow',
    overdue: '#f64565',
    cancelled: '#ee312f',
    planned: '#228ec8',
    closed: 'green',
    saved: '#228ec8',
    approvedWithWarning: '#9d673f',
    approved: 'green',
    publishedWithWarning: '#2aa092',
    published: '#6626ed',
    recalled: '#bb0003',
}
